import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem, Theme } from '../../../../../__styling'

const { neutral } = tokens.thenightly.colors.palette

interface BulletProps {
    theme?: Theme
    removeMargin?: boolean
}

export const Bullet = styled.span<BulletProps>(
    ({ theme, removeMargin = false }) => {
        return {
            width: 2,
            height: 2,
            margin: removeMargin
                ? 0
                : `0 ${calcRem(theme.margins.sm)} 0 ${calcRem(
                      theme.margins.sm,
                  )}`,
            borderRadius: 1,
            backgroundColor: neutral[60],
        }
    },
)
